import { IFIStatus, Permission } from '@cims-online/shared'
import { IdentifiedFieldIssue } from '../../../../../IFITrackerContext/types'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { Button } from 'antd'
import { useIFITrackerContext } from '../../../../../IFITrackerContext'

const Status: React.FC<IdentifiedFieldIssue> = (record) => {
  const { review } = useIFITrackerContext()
  const can = useCheckPermission(Permission.ReviewIdentifiedFieldIssue)
  const { name, id } = IFIStatus.fromIdOrFail(record.statusId)
  if (!can || id === IFIStatus.Closed.id) return <>{name}</>
  return (
    <Button
      type="link"
      style={{ whiteSpace: 'normal', padding: 0, display: 'inline-flex' }}
      onClick={() => review.toggle(record)}
    >
      {name}
    </Button>
  )
}

export default Status
